import {Plan} from './plan';
import {HasPermission} from './has-permission';
import {Permission} from './permission';

export class Subscription implements HasPermission {
  id: number;
  //plan_id: number;
  plan: Plan;
  credits: number;
  users: number;
  credits_extra: number;
  credits_extra_total: number;
  payment_frequency: string;
  // Null once the contract is past its last renewal, or when the plan does not renew at
  // all — fixed-allocation subscriptions sit there permanently, and they are the cohort
  // that misreads its balance. Callers must handle the null; do not narrow this type.
  next_credit_update: Date | null;
  contract_start_at: Date;
  contract_expire_at: Date;
  created_at: Date;
  updated_at: Date;
  permissions: Permission[];

  constructor(credits: number, users: number, payment_frequency: string, contract_start_at: Date, contract_expire_at: Date) {
    this.credits = credits;
    this.users = users;
    this.payment_frequency = payment_frequency;
    this.contract_start_at = contract_start_at;
    this.contract_expire_at = contract_expire_at;
  }

  static dailyCredits(subscription: Subscription): number {
    const monthlyCredits = subscription.plan.credits;
    const extraCredits = subscription.credits_extra;
    const contractStart = new Date(subscription.contract_start_at);
    const contractEnd = new Date(subscription.contract_expire_at);

    const diffInMs = Math.abs(contractEnd.getTime() - contractStart.getTime());
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    const dailyCredits = monthlyCredits / 30;
    const dailyExtraCredits = extraCredits / diffInDays;

    return dailyCredits + dailyExtraCredits;
  }

  // The two balances have different lifecycles — the monthly one is reset by the backend
  // on renewal, the extra one lasts the whole contract — but a customer only ever cares
  // about how many reports they can still launch. Never surface them separately.
  static totalCredits(subscription: Subscription): number {
    return subscription.credits + subscription.credits_extra;
  }

  // Spend the monthly balance first: it is the one that expires at renewal. Neither
  // balance may go below zero — callers decrement after any accepted launch, including
  // ones the backend served without debiting (credit-free permission), and a negative
  // here would make totalCredits report less than the user can actually still spend.
  static substractCredit(subscription: Subscription) {
    if (subscription.credits > 0) subscription.credits--;
    else if (subscription.credits_extra > 0) subscription.credits_extra--;
  }
}
